import React from "react";

export const getAfterSuffix = (afterSuffix) => {
  return afterSuffix?.[React.i18n.language] ? afterSuffix?.[React.i18n.language] : "";
}